import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../styles/EditarListaDeEmpaqueModal.css";
import "../styles/Historico.css"; // [EXPERT_FIX]: Importar estilos específicos para este modal
import TotalesEncabezadoListaEmpaque from "../Componentes/Totalesencabezadolistaempaque";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// [EXPERT]: Definiciones estables fuera del componente para evitar re-creación en cada render
const columnasEsperadas = [
  { field: "nroCaja", header: "NRO CAJA", width: "80px" },
  { field: "RefInterna", header: "REF PRODUCTO", width: "120px" },
  { field: "RefProveedor", header: "REF PROVEEDOR", width: "120px" },
  { field: "ImagenProducto", header: "FOTO", width: "80px" },
  { field: "MarcaCaja", header: "MARCA", width: "100px" },
  { field: "Descripcion", header: "DESCRIPCION", width: "220px" },
  { field: "Material", header: "MATERIAL", width: "100px" },
  { field: "Serial", header: "SERIAL", width: "100px" },
  { field: "MarcaProducto", header: "MARCA (PRODUCTO)", width: "120px" },
  { field: "UnidadMedida", header: "UNIDAD MEDIDA", width: "90px" },
  { field: "Modelo", header: "MODELO", width: "100px" },
  { field: "PesoBruto", header: "PESO BRUTO", width: "95px" },
  { field: "CantCajas", header: "CANT CAJAS", width: "85px" },
  { field: "CantPiezasPorCaja", header: "PCS / CAJA", width: "85px" },
  { field: "CantTotal", header: "CANT TOTAL", width: "85px" },
  { field: "CBMTotal", header: "CBM TOTAL", width: "85px" },
  { field: "CubCaja", header: "CUBICAJE / CAJA", width: "100px" },
  { field: "PesoCaja", header: "PESO / CAJA", width: "90px" },
  { field: "TipoMcia", header: "TIPO MCIA", width: "80px" },
  { field: "Importador", header: "IMPORTADOR", width: "110px" },
];

const translations = {
  es: {
    titulo: "Historico Lista de Empaque",
    cancelar: "Cancelar",
    guardar: "Guardar",
    advertencia: "Advertencia",
    noDatos: "No hay datos cargados.",
    guardadoExito: "Datos guardados con éxito.",
    guardadoError: "Error al guardar los datos.",
  },
  en: {
    titulo: "Packing List Record",
    cancelar: "Cancel",
    guardar: "Save",
    advertencia: "Warning",
    noDatos: "No data loaded.",
    guardadoExito: "Data saved successfully.",
    guardadoError: "Error saving data.",
  },
  zh: {
    titulo: "编辑装箱单",
    cancelar: "取消",
    guardar: "保存",
    advertencia: "警告",
    noDatos: "未加载数据。",
    guardadoExito: "数据保存成功。",
    guardadoError: "保存数据时出错。",
  },
};

const HistoricoModal = ({
  isOpen,
  onClose,
  pedido,
  onSaveSuccess,
  language,
}) => {
  const [previewData, setPreviewData] = useState([]); // Datos cargados para previsualización
  const [expandedRows, setExpandedRows] = useState([]); // [EXPERT]: Inicializar como array vacío para estabilidad
  const toast = React.useRef(null);
  const isMounted = React.useRef(false);

  // [EXPERT]: Memoizar traducciones para estabilidad en dependencias
  const t = useMemo(
    () => translations[language] || translations.es,
    [language],
  );

  // Función para agrupar los datos por número de contenedor
  const groupDataByContainer = (data) => {
    const grouped = data.reduce((acc, item) => {
      const containerId = item.IdContenedor || "Sin Contenedor"; // Usar IdContenedor
      if (!acc[containerId]) {
        acc[containerId] = {
          IdContenedor: containerId, // Usar IdContenedor
          listasEmpaque: [],
        };
      }
      acc[containerId].listasEmpaque.push(item);
      return acc;
    }, {});
    return Object.values(grouped);
  };

  useEffect(() => {
    isMounted.current = true; // El componente está montado
    if (isOpen) {
      fetchWithAuth(`${API_URL}/api/editar-lista-empaque/${pedido.idpedido}`)
        .then((response) => response.json())
        .then((data) => {
          console.log(
            "Datos originales recibidos de la API en HistoricoModal:",
            data,
          ); // Log para depuración
          if (isMounted.current) {
            // Agrupar los datos por número de contenedor
            const groupedData = groupDataByContainer(data);
            setPreviewData(groupedData);
          }
        })
        .catch((err) => {
          console.error("Error al cargar la lista de empaque:", err);
          if (toast.current && isMounted.current) {
            toast.current.show({
              severity: "error",
              summary: t.guardadoError,
              detail: t.guardadoError,
            });
          }
        });
    }
    return () => {
      isMounted.current = false; // El componente se desmonta
    };
  }, [isOpen, pedido.idpedido, t]);

  /************** Totales de mercancía y array para mostrarlos **************/
  /*   const sumaCMBTotal = previewData.reduce((acc, row) => {
    const valor = parseFloat(row.CBMTotal) || 0; // Convierte a número, usa 0 si es NaN
    return acc + valor; // Suma el valor al acumulador
  }, 0);

  const tiposMciaTotales = previewData.reduce((acc, row) => {
    const tipo = row.TipoMcia || "Sin Tipo"; // Asegúrate de que haya un valor válido
    acc[tipo] = (acc[tipo] || 0) + 1; // Incrementa el contador del tipo
    return acc;
  }, {});

  const tiposMciaArray = Object.entries(tiposMciaTotales).map(([tipo, cantidad]) => `${tipo}: ${cantidad}`); */

  /* const handleSave = async () => {
    if (previewData.length === 0) {
      if (toast.current && isMounted.current) {
        toast.current.show({
          severity: "warn",
          summary: t.advertencia,
          detail: t.noDatos,
        });
      }
      return;
    }

    try {
      const response = await fetchWithAuth(`${API_URL}/api/editar-lista-empaque/${pedido.idpedido}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: previewData }),
      });

      if (response.ok) {
        if (toast.current && isMounted.current) {
          toast.current.show({
            severity: "success",
            summary: t.guardadoExito,
            detail: "",
          });
        }
        if (onSaveSuccess) onSaveSuccess();
        onClose();
      } else {
        const error = await response.json();
        if (toast.current && isMounted.current) {
          toast.current.show({
            severity: "error",
            summary: t.guardadoError,
            detail: error.message || t.guardadoError,
          });
        }
      }
    } catch (err) {
      console.error("Error al guardar la lista de empaque:", err);
      if (toast.current && isMounted.current) {
        toast.current.show({
          severity: "error",
          summary: t.guardadoError,
          detail: t.guardadoError,
        });
      }
    }
  }; */

  // [EXPERT]: Memoizar las columnas internas para evitar re-creaciones en cada renderizado del template
  const internalColumns = useMemo(() => {
    return columnasEsperadas.map((col) => (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        style={{
          minWidth: col.width,
          maxWidth: col.width,
          textAlign: "center",
        }}
      />
    ));
  }, []); // columnasEsperadas es estática fuera del componente

  const rowExpansionTemplate = useCallback(
    (data) => {
      return (
        <div className="p-3 table-historico-nested">
          <h5 className="nested-table-title">
            Listas de Empaque para el Contenedor: {data.IdContenedor}
          </h5>
          <DataTable
            value={data.listasEmpaque}
            responsiveLayout="scroll"
            scrollable
            className="p-datatable-sm"
            tableStyle={{ minWidth: "2200px" }}
          >
            <Column
              field="idpedido"
              header="ID PEDIDO"
              style={{
                minWidth: "80px",
                maxWidth: "80px",
                textAlign: "center",
              }}
            />
            {internalColumns}
          </DataTable>
        </div>
      );
    },
    [internalColumns],
  );

  // Columnas para el DataTable principal del modal
  const modalColumnElements = useMemo(
    () => [
      <Column key="expander" expander style={{ width: "3em" }} />,
      <Column key="idcontenedor" field="IdContenedor" header="ID Contenedor" />,
    ],
    [],
  );

  return (
    <Dialog
      header={t.titulo}
      visible={isOpen}
      style={{ width: "95vw", height: "90vh" }}
      className="historico-dialog"
      modal
      contentStyle={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
      onHide={onClose}
    >
      <Toast ref={toast} />

      <TotalesEncabezadoListaEmpaque
        pedido={pedido}
        previewData={previewData}
      />

      {previewData.length > 0 && (
        <DataTable
          value={previewData}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey="IdContenedor" // Cambiar a IdContenedor
          scrollable
          scrollHeight="100%"
          className="p-datatable-sm full-height-table"
          style={{ flex: "1 1 auto", height: "100%", minHeight: 0 }}
        >
          {modalColumnElements}
        </DataTable>
      )}

      <div className="p-dialog-footer">
        <Button
          id="btn-historico-modal-cerrar"
          label={"Cerrar"}
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={onClose}
        />
      </div>
    </Dialog>
  );
};

export default HistoricoModal;
